import { render, staticRenderFns } from "./addrelation.vue?vue&type=template&id=0beb05c9&scoped=true"
import script from "./addrelation.vue?vue&type=script&lang=js"
export * from "./addrelation.vue?vue&type=script&lang=js"
import style0 from "./addrelation.vue?vue&type=style&index=0&id=0beb05c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0beb05c9",
  null
  
)

export default component.exports